/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserProfile = {
    /**
     * medical credentials to display immediately after the user's name, e.g. MD, DO
     */
    credentials?: string | null;
    /**
     * title, such as 'board certified dermatologist', to display in the line after the users name on case reports they sign
     */
    title?: string | null;
    /**
     * Contact phone number for the user. Will display in the Viewer if the user is the `ordering_doctor`.
     */
    phone?: string | null;
    enable_macro_helpers?: boolean;
    mfa_method?: UserProfile.mfa_method | null;
    /**
     * National Provider Identifier used to map integration ordering_physician requests.
     */
    npi?: number | null;
    /**
     * Whether the user is considered archived. This allows them to log in but prevents them from viewing unassigned cases.
     */
    is_archived?: boolean;
    user_type?: UserProfile.user_type;
}

export namespace UserProfile {

    export enum mfa_method {
        EMAIL = 'email',
        SMS = 'sms',
        APP = 'app',
    }

    export enum user_type {
        DERMPATH = 'dermpath',
        PHYSICIAN = 'physician',
        LAB_ADMIN = 'lab_admin',
        CLINIC_ADMIN = 'clinic_admin',
        DEMO = 'demo',
        ADMIN = 'admin',
        UNKNOWN = 'unknown',
        MRMC2021 = 'MRMC2021',
    }


}
